import React from "react";
import styled from "styled-components";
import { TokenLogo } from "@/components/TokenLogo";
import { tokenLogos } from "@/constants/tokenLogos";
import { maxTokenDecimals } from "@/placeholders/tokens";
import { formatDisplayShorthand } from "@/utils/formatDisplay";

export const TokenCell = ({ value }: any) => {
  const [tokens, amounts] = [value.tokens, value.amounts];
  return (
    <Column>
      {tokens.map((token: any, index: number) => {
        const LogoIcon = tokenLogos[token] ? tokenLogos[token] : Logo;
        return (
          <TokenGroup key={token}>
            <LogoIcon />
            <TokenDetails>
              <TokenAmount>
                {formatDisplayShorthand(
                  amounts[index],
                  maxTokenDecimals(token),
                  1e4
                )}
              </TokenAmount>
              <TokenName>{token}</TokenName>
            </TokenDetails>
          </TokenGroup>
        );
      })}
    </Column>
  );
};

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
`;

const TokenGroup = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  > img {
    height: 32px;
    width: 32px;
    margin: 0;
  }

  > svg {
    margin: 8px;
    width: 70px;
    position: absolute;
    left: -30px;
    top: 8px;
  }
`;

const TokenDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  position: relative;
`;

const TokenName = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #7d7d97;
  //width: 48px;
`;

const TokenAmount = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #ffffff;
  //width: 48px;
`;

const Logo = styled(TokenLogo)`
  width: 30px;
`;
